import React, { useRef, useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";

import SvgComponent from "../components/Svg2Component";

//librerias de microsoft
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../microsoft/authConfig";
import { iniciarSesionMicrosoft } from "../service/apiService";

function Dashboard() {
 
  const { instance, accounts } = useMsal();
  const [datosExcel, setDatosExcel] = useState([]);

  
  useEffect(() => {
    const loginAndFetchExcel = async () => {
      try {
        // let account = instance.getActiveAccount();

        // // Inicia sesión si no hay cuenta activa
        // if (accounts.length === 0) {

        //   const loginResponse = await instance.loginPopup(loginRequest);
        //   account = loginResponse.account;
        //   console.log("Logueado como :", loginResponse.account.username);

        //   // Lo establece como cuenta activa
        //   instance.setActiveAccount(account);
        // }

        // //Obtiene el token
        // const tokenResponse = await instance.acquireTokenSilent({
        //   ...loginRequest,
        //   account: account,
        // });

        // const accessToken = tokenResponse.accessToken;
        const accessToken = await iniciarSesionMicrosoft();

        const driveId = "b!lwp5CudIwEiBZPypSPW71y6pboWNzY9PlnZlYSQb570bW9liL1kQRIUjuEjaWYi_";
        const itemId = "01RTYIYHPKFI4ELIP45RHKBKDX6C3NKKLO";
        const worksheetName = "qry_combinado";

        const endpoint = `https://graph.microsoft.com/v1.0/drives/${driveId}/items/${itemId}/workbook/worksheets('${worksheetName}')/usedRange`;

        // Sitio de sharepoint
        const response = await fetch(endpoint, {
          headers: {
            Authorization: `Bearer ${accessToken.data?.access_token}`,
          },
        });


        const data = await response.json();
        const allRows = data.values;

        // Elimina los encabezados del exel:
        const rowsWithoutHeader = allRows.slice(1);
        setDatosExcel(rowsWithoutHeader);
      } catch (err) {
        console.error(err);
      }
    };

    loginAndFetchExcel();
  }, [instance, accounts]);
  

  /*
  useEffect(() => {
    const loginAndFetchExcel = async () => {
      try {
        let account = instance.getActiveAccount();

        if (!account && accounts.length === 0) {
          // loginRedirect es más estable en Electron
          await instance.loginRedirect(loginRequest);
          return;
        }

        if (!account && accounts.length > 0) {
          account = accounts[0];
          instance.setActiveAccount(account);
        }

        const tokenResponse = await instance.acquireTokenSilent({
          ...loginRequest,
          account: account,
        });

        const accessToken = tokenResponse.accessToken;

        // Ejemplo: leer una hoja de Excel en OneDrive
        const response = await fetch(
          "https://graph.microsoft.com/v1.0/me/drive/root:/Ore Control Media Luna Test.xlsm:/workbook/worksheets('qry_combinado')/usedRange",
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        const data = await response.json();
        const allRows = data.values || [];
        setDatosExcel(allRows.slice(1)); // quitar encabezados
      } catch (err) {
        console.error("Error en login/fetch:", err);
      }
    };

    loginAndFetchExcel();
  }, [instance, accounts]);
  */

  return (
    <section className="bg-fondo_blanco shadow-xl rounded-lg">
      <div className="h-[calc(82vh)] w-full flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">  
        <p 
          className="text-ceniza font-worksans text-[45px] font-bold uppercase  pointer-events-none select-none"
          style={{
            position: "absolute",
            top: "16%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            whiteSpace: "nowrap",
            letterSpacing: "7px",
            zIndex: 1000,
            opacity: 0.5
          }}
        >
          Grade Control System Media Luna
        </p>
        <SvgComponent datosExcel={datosExcel}/>
        <ul
          className="text-ceniza font-worksans text-[25px] font-bold uppercase  pointer-events-none select-none"
          style={{
            position: "absolute",
            bottom: "10%",
            left: "15%",
            transform: "translate(-50%, -50%)",
            whiteSpace: "nowrap",
            letterSpacing: "7px",
            zIndex: 1000,
            opacity: 0.5
          }}
        >
          <li> RB = RockBraker  </li>
          <li> OP = OrePass  </li>
          
        </ul>
      </div>
    </section>
  );
}

export default Dashboard;
